export default [
  {
    path: '/indications',
    component: () => import(/* webpackChunkName: "providers" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
    },
  },
];
